const PropTypes = require('prop-types');
const React = require('react');
const { filter } = require('lodash');
const PromoProduct = require('./promo_product.jsx');
const Savings = require('./savings.jsx');
const PriceWithChange = require('./price_with_change.jsx');
const ProductBundleCalculator = require('./product_bundle_calculator.js');

class ProductBundlePreview extends React.Component {
  static propTypes = {
    productBundle: PropTypes.object.isRequired,
  };

  bundledProductsWithListings = () => {
    return filter(this.props.productBundle.bundled_products, function (bundledProduct) {
      return bundledProduct.listing;
    });
  };

  renderBundledListings = () => {
    return this.bundledProductsWithListings().map(function (bundledProduct, index) {
      return <PromoProduct key={index} listing={bundledProduct.listing} discountedPrice={bundledProduct.listing.price} originalPrice={bundledProduct.listing.original_price} />;
    });
  };

  renderSavings = () => {
    return <Savings price={ProductBundleCalculator.originalPrice(this.props.productBundle)} discountedPrice={ProductBundleCalculator.discountedPrice(this.props.productBundle)} symbol={this.props.productBundle.main_listing.price.symbol} bundledProductsCount={ProductBundleCalculator.bundledProductsCount(this.props.productBundle)} />;
  };

  render() {
    return (
      <div className="product-bundle-preview">
        <PromoProduct listing={this.props.productBundle.main_listing} originalPrice={this.props.productBundle.main_listing.price} />
        {this.renderBundledListings()}
        <div className="align-center">
          <h4 className="heading-2 mt-1"><PriceWithChange price={ProductBundleCalculator.totalPrice(this.props.productBundle)} /></h4>
          {this.renderSavings()}
        </div>
        <a className="btn btn-primary btn-disabled wide mt-1">{I18n.t('js.productBundles.promo.addToCart', { count: ProductBundleCalculator.bundledProductsCount(this.props.productBundle), totalCount: ProductBundleCalculator.bundledProductsCount(this.props.productBundle) + 1 })}</a>
      </div>
    );
  }
}

module.exports = ProductBundlePreview;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle_preview.jsx